import React, { useState,useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';

function Verification() {
    const [showModal, setShowModal] = useState(false);

    const handleModalClose = () => {
      setShowModal(false);
      document.body.classList.remove('modal-open-custom');
    };
  
    // const handleModalShow = (e) => {
    //   e.preventDefault();
    //   setShowModal(true);
    //   document.body.classList.add('modal-open-custom');
  
    //   const closeBtn = document.querySelector('.btn-header-nav-toggle');
    //   if (closeBtn) {
    //     closeBtn.click();
    //   }
    // };
    return (
        <>
            {/* Add Modal */}
            {/* <button className='btn-green-38B652' onClick={handleModalShow}>Verifications</button> */}
      <Modal className='varification_pop' show={showModal} onHide={handleModalClose} size="lg" scrollable>
        
        <Modal.Body className='p-4'>
        <Button variant="secondary btn-close position-absolute top-15 right-15" onClick={handleModalClose}></Button>
          
          <div className="row g-4">
            <div className='col-12'><Modal.Title className='font-700 text-primary-color'>CERTIFICATE<br/> VERIFICATION APPLICATION</Modal.Title></div>
            <div className="col-md-6">
              <div className='row g-4'>
                  <div className="col-12">
                    <div className='form-title'>
                      <span>Candidate Details</span>
                    </div>
                  </div>
                  <div className="col-12">
                     <div className='row g-3'>
                        <div className='col-12'>
                          <div className='position-relative'>
                            <input type="text" className='form-control' id='surname' required/>
                            <label htmlFor="surname"><span className='text-orange-ef3e33'>*</span>Surname</label>
                          </div>
                        </div>
                        <div className='col-12'>
                          <div className='position-relative'>
                            <input type="text" className='form-control' id='surname' required/>
                            <label htmlFor="surname"><span className='text-orange-ef3e33'>*</span>Given Names</label>
                          </div>
                        </div>
                        <div className='col-12'>
                          <div className='position-relative'>
                            <input type="text" className='form-control' id='surname' required/>
                            <label htmlFor="surname"><span className='text-orange-ef3e33'>*</span>Identity/Passport Number</label>
                          </div>
                        </div>
                        <div className='col-12'>
                          <div className='position-relative'>
                            <input type="text" className='form-control' id='surname' required/>
                            <label htmlFor="surname"><span className='text-orange-ef3e33'>*</span>Certificate Number</label>
                          </div>
                        </div>
                     </div>
                  </div>
                  <div className="col-12">
                    <div className='form-title'>
                      <span>Verificatory Details</span>
                    </div>
                  </div>
                  <div className="col-12">
                     <div className='row g-3'>
                        <div className='col-12'>
                          <div className='position-relative'>
                            <input type="text" className='form-control' id='surname' required/>
                            <label htmlFor="surname"><span className='text-orange-ef3e33'>*</span>Verifier Name</label>
                          </div>
                        </div>
                        <div className='col-12'>
                          <div className='position-relative'>
                            <input type="text" className='form-control' id='surname' required/>
                            <label htmlFor="surname"><span className='text-orange-ef3e33'>*</span>Verifier Surname</label>
                          </div>
                        </div>
                        <div className='col-12'>
                          <div className='position-relative'>
                            <input type="text" className='form-control' id='surname' required/>
                            <label htmlFor="surname"><span className='text-orange-ef3e33'>*</span>Verifier Designation (Insert Certificates tittle)</label>
                          </div>
                        </div>
                        <div className='col-12'>
                          <div className='position-relative'>
                            <input type="text" className='form-control' id='surname' required/>
                            <label htmlFor="surname"><span className='text-orange-ef3e33'>*</span>Verifier Email Address</label>
                          </div>
                        </div>
                        <div className='col-12'>
                          <div className='position-relative'>
                            <input type="text" className='form-control' id='surname' required/>
                            <label htmlFor="surname"><span className='text-orange-ef3e33'>*</span>Confirm Verifier Surname</label>
                          </div>
                        </div>
                        <div className='col-12'>
                          <div className='position-relative'>
                            <input type="text" className='form-control' id='surname' required/>
                            <label htmlFor="surname"><span className='text-orange-ef3e33'>*</span>Verifier Designation (Insert Certificates tittle)</label>
                          </div>
                        </div>
                        <div className='col-12'>
                          <div className='position-relative'>
                            <input type="text" className='form-control' id='surname' required/>
                            <label htmlFor="surname"><span className='text-orange-ef3e33'>*</span>Confirm  Verifier Email Address</label>
                          </div>
                        </div>
                        <div className='col-12'>
                          <div className='position-relative'>
                            <select className="form-select" aria-label="Default select example" required>
                              <option selected>*Verifier’s Organization Type</option>
                              <option value="1">One</option>
                              <option value="2">Two</option>
                              <option value="3">Three</option>
                            </select>
                            <label htmlFor="surname"><span className='text-orange-ef3e33'>*</span>Verifier’s Organization Type</label>
                          </div>
                        </div>
                        <div className='col-12'>
                          <div className='position-relative'>
                            <input type="text" className='form-control' id='surname' required/>
                            <label htmlFor="surname"><span className='text-orange-ef3e33'>*</span>Verifier’s Organization</label>
                          </div>
                        </div>
                     </div>
                  </div>
              </div>
             
            </div>
            <div className="col-md-6">
              <div className='row flex-column h-100'>
                <div className='col'>
                    <div className='bg-primary-green p-4 p-lg-5 text-white d-flex flex-column align-items-center text-center h-100'>
                      <h5 className='mb-4'>Subscribe<br/> to Newsletter</h5>
                      <p className='mb-4 font-23'>was established on the<br className='d-none d-lg-block'/> 1st of April 1998 under<br className='d-none d-lg-block'/> the SAMSA Act 5 of<br className='d-none d-lg-block'/> 1988</p>
                      <div className='bg-white px-4 py-3 rounded-2 text-gray-4c mb-4'><span className='text-orange-ef3e33 me-1'>*</span>Givemorre@ providence.gov.za</div>
                       <button className='btn btn-signup mb-4'>Sign up</button>
                       
                       <i className="bi bi-patch-check"></i>
                      
                     
                      <div className='font-18 mb-4'>By Subscribing, you’re accept <span className='d-block font-600'>Privacy Policy</span></div>
                      <div className='support-text'>support@samsa.gov.za
                        <span className='d-block'>+ 27 11 254 6698</span></div>
                    </div>
                </div>
                <div className='col-auto mt-3'>
                    <Button variant="submit" onClick={handleModalClose}>Submit</Button>
                </div>

              </div>
              
              
            </div>
          </div>
        </Modal.Body>

      </Modal>

      {/* ...existing code... */}
        </>
    )
}

export default Verification;